require('jquery')

jQuery(function () {
  adjustmentBanner()

  $(window).ready(function () {
    calculateBanner()
    adjustmentBanner()
    packeryTabs()
  })

  $(window).on('load', function () {
    calculateBanner()
  })
  $(window).on('resize', function () {
    calculateBanner()
    adjustmentBanner()
  })
})

function calculateBanner() {
  let widthWindow = $(window).width(),
    widthContainer = $('#containerBanner').width(),
    widthTitleBanner = $('#titleBanner').width(),
    widthResult = (widthWindow - widthContainer) / 2,
    total = widthResult + widthTitleBanner,
    headerHeight = $('.header1').height()

  $('#filterBanner').width(total + 95)

  if ($(window).height() < 700) {
    $('#titleBanner').css({
      paddingTop: headerHeight + 70,
      display: 'block !important'
    })
  } else {
    $('#titleBanner').css('padding-top', headerHeight / 2)
  }
}

function adjustmentBanner() {
  let bannerA = $('.slick-banner').height()
  $('.slick-banner .figure').css({
    height: bannerA
  })
}

function packeryTabs() {
  $('.nav-pills .nav-link').on('click', function () {
    $('.packery').packery('destroy')
    setTimeout(function () {
      $('.packery').packery({
        itemSelector: '.grid-item',
        gutter: 10
      })
    }, 250)
  })
}
